import { h } from 'preact';
import PropTypes from 'prop-types';

import { useSubscribe } from '../../hooks/use-subscribe';
import TextToSpeech from '../../containers/text-to-speech/text-to-speech';
import { textToSpeechActions, textToSpeechStore } from '../../../global-store/subjects/text-to-speech';

export const TextToSpeechComponent = ({ $root, htmlProps, widget }) => {
  const state = useSubscribe(textToSpeechStore);
  return (
    <TextToSpeech htmlProps={htmlProps} widget={widget} $root={$root} state={state} actions={textToSpeechActions} />
  );
};

TextToSpeechComponent.propTypes = {
  htmlProps: PropTypes.object.isRequired,
  $root: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};
